<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="父级字典值" prop="parentDictItemId">
        <el-cascader aria-hidden="false" :options="options" :props="props" v-model="queryParams.parentDictItemId"
          @change="handleChangeParentDictItemId" placeholder="请选择字典值父级" clearable />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="字典值名称" prop="dictLabel">
        <el-input v-model.trim="queryParams.dictLabel" placeholder="请输入字典值名称" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="状态" prop="status">
        <el-select-dict dictType="STATUS" clearable placeholder="请选择状态" v-model="queryParams.status"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermi="['system:dictItem:create']" type="primary" plain icon="el-icon-plus" size="mini"
          @click="handleAdd">新增</el-button>
        <el-button v-hasPermi="['system:dictItem:update']" type="success" plain icon="el-icon-edit" size="mini"
          :disabled="single" @click="handleUpdate">编辑</el-button>
        <el-button v-hasPermi="['system:dictItem:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="dictItemTable" :class="{ 'empty': list.length === 0 }" empty-text=" " v-loading="loading"
          :data="list" row-key="dictItemId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column :selectable="checkSelectable" type="selection" :reserve-selection="true" width="55"
            align="center" />

          <el-table-column label="字典类型" prop="dictCode" align="center" min-width="200px">
          </el-table-column>
          <el-table-column label="字典类型名称" prop="dictName" align="center" min-width="200px">
          </el-table-column>
          <el-table-column label="字典值名称" prop="dictLabel" align="center" min-width="200px">
            <template slot-scope="scope">
              <el-link type="primary" @click.native.stop="
                handleChangeParentDictItemId(scope.row.dictItemId)
                ">{{ scope.row.dictLabel }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="字典值" prop="dictValue" align="center" min-width="200px">
          </el-table-column>
          <el-table-column-dict dictType="STATUS" dictTypeNode="tag" label="字典类型状态" align="center" prop="dictStatus"
            min-width="128px"></el-table-column-dict>
          <el-table-column-dict dictType="STATUS" dictTypeNode="tag" label="状态" align="center" prop="status"
            min-width="100px"></el-table-column-dict>
          <el-table-column-dict dictType="ENABLE_DISABLE" dictTypeNode="tag" label="禁选状态" align="center"
            prop="dictDisabled" min-width="100px"></el-table-column-dict>
          <el-table-column-dict dictType="YES_NO" label="是否系统预设" align="center" prop="isSystem"
            min-width="120px"></el-table-column-dict>
          <el-table-column label="操作人" prop="creator.userName" show-overflow-tooltip align="center" min-width="168px">
            <template slot-scope="scope">
              <div class="operater-box flex-c-c">
                <div class="operater-content-box">
                  <div class="top">
                    <span class="label">创建人：</span>
                    <span class="value">{{ scope.row.creator?.userName || "--" }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">更新人：</span>
                    <span class="value">{{ scope.row.updater?.userName || "--" }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column dateFormat="datetime" label="操作时间" align="center" prop="createTime" min-width="256px">
            <template slot-scope="scope">
              <div class="operater-box flex-c-c">
                <div class="operater-content-box">
                  <div class="top">
                    <span class="label">创建时间：</span>
                    <span class="value">{{ scope.row.createTime | formatDate("datetime", "--") }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">更新时间：</span>
                    <span class="value">{{ scope.row.updateTime | formatDate("datetime", "--") }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="
            hasPermi([
              'system:dictItem:status',
              'system:dictItem:disabled',
              'system:dictItem:read',
              'system:dictItem:delete',
            ])
          " label="操作" align="center" width="328px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button v-hasPermi="['system:dictItem:status']" :disabled="scope.row.isSystem === '1'" size="mini"
                :type="scope.row.status === '1' ? 'warning' : 'success'"
                @click.native.stop="handleStatusChange(scope.row)">{{ scope.row.status === "1" ? "停用" : "启用"
                }}</el-button>
              <el-button v-hasPermi="['system:dictItem:status']" :disabled="scope.row.isSystem === '1'" size="mini"
                :type="scope.row.dictDisabled === '0' ? 'warning' : 'success'"
                @click.native.stop="handleDisabledChange(scope.row)">{{ scope.row.dictDisabled === "1" ? "可选" : "禁选"
                }}</el-button>
              <el-button v-hasPermi="['system:dictItem:read']" size="mini" type="primary" icon="el-icon-view"
                @click.native.stop="handleUpdate(scope.row)">查看</el-button>
              <el-button v-hasPermi="['system:dictItem:delete']" :disabled="scope.row.isSystem === '1'" size="mini"
                type="danger" icon="el-icon-delete" @click.native.stop="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>

    <!-- 添加或修改对话框 -->
    <dict-item-dialog ref="dictItemDialog" :options="options" :props="props" :visible.sync="open"
      :modal-append-to-body="false" :close-on-click-modal="false" :isUpdate="isUpdate" :baseForm="baseForm"
      @close="open = false" @successs="handleSuccess" width="1024px"></dict-item-dialog>
  </div>
</template>

<script>
import { dictItemApi } from "@/api"
import DictItemDialog from "./components/dict-item-dialog.vue"
export default {
  name: "systemDictItemManage",
  components: {
    DictItemDialog
  },
  data() {

    return {
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        dictId: null, // 字典项id
        parentDictItemId: "ROOT_VALUE", // 父字典值value
        dictLabel: "", //字典值名称
        status: "", //字典值状态
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dictId: null, // 字典项id
      dateRange: [],
      list: [],
      selection: [], //选中的项
      loading: false,
      total: 0,

      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,

      open: false,
      // 表单参数
      baseForm: {
        parentDictItemId: "ROOT_VALUE", // 父级元素id
        dictId: null,
        dictValue: "", // 字典值
        dictLabel: "", // 字典值名称
        elementType: "", // element类型
        vantType: "", // vant类型
        color: "", // 颜色
        jsonstr: "", // 额外的JSON数据
        remark: "" // 备注
      },

      props: {
        value: "dictItemId",
        label: "dictLabel",
        checkStrictly: true,
        emitPath: false
      },
      options: [] // 字典值父元素id
    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          parentDictItemId: this.baseForm.parentDictItemId, // 父级元素id
          dictId: this.dictId,
          dictValue: "", // 字典值
          dictLabel: "", // 字典值名称
          elementType: "", // element类型
          vantType: "", // vant类型
          color: "", // 颜色
          remark: ""
        }
        this.$refs.dictItemDialog && this.$refs.dictItemDialog.resetForm()
      }
    }
  },
  created() {
    this.dictId = Number(this.$route.query.dictId)
    this.baseForm.dictId = this.dictId
    this.queryParams.dictId = this.dictId
    //获取列表
    this.getList()
    // 获取所有字典值
    this.getALlDictItemByDictId()
  },
  methods: {
    // 成功事件
    handleSuccess() {
      this.getList()
      this.getALlDictItemByDictId()
    },
    // 父节点改变事件
    handleChangeParentDictItemId(dictItemId) {
      this.queryParams.parentDictItemId = dictItemId
      this.baseForm.parentDictItemId = dictItemId
      this.handleQuery()
    },
    // 获取所有字典值
    getALlDictItemByDictId() {
      dictItemApi
        .getALlDictItemByDictId({ dictId: this.dictId })
        .then((data) => {
          this.options = [
            {
              dictLabel: "根目录",
              dictItemId: "ROOT_VALUE",
              children: data
            }
          ]
        })
    },
    // 系统内设用户 禁止操作
    checkSelectable(row, index) {
      if (row.isSystem === "1") {
        return false
      } else {
        return true
      }
    },
    //点击行
    clickRow(row) {
      //系统预设用户 不做处理
      if (row.isSystem === "1") {
        return
      }
      this.$refs.dictItemTable.toggleRowSelection(row)
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.btnBlur()

      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.dictItemId)
        str += item.dictLabel
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }
      const dictId = Number(this.$route.query.dictId)
      this.$modal
        .confirm('是否确认删除字典项为"【' + str + '】"的数据项？')
        .then(function() {
          return dictItemApi.batchDeleteItems({
            ids,
            dictId
          })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除字典成功")
        })
        .catch(() => { })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // 清空已选项
      this.$refs.dictItemTable.clearSelection()
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.baseForm.parentDictItemId = null
      this.resetForm("queryForm")
      this.handleQuery()
    },
    /** 查询字典值列表 */
    getList() {
      this.loading = true
      dictItemApi
        .getList(this.addDateRange(this.queryParams, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true
    },

    /** 修改按钮操作 */
    handleUpdate(row) {
      if (!row.dictId) {
        this.isUpdate = true
      }
      const id =
        row.dictItemId || (this.selection[0] && this.selection[0].dictItemId)
      dictItemApi.getDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // 让按钮返回原样
      this.btnBlur()
            
      const id = row.dictItemId
      this.$modal
        .confirm('是否确认删除字典为"' + row.dictLabel + '"的数据项？')
        .then(function() {
          return dictItemApi.deleteItem({ id })
        })
        .then(() => {
          this.handleQuery()
          this.getALlDictItemByDictId()
          // 判断删除的项是否被勾选了
          const flag = this.selection.find((item) => item.dictItemId === id)
          flag && this.$refs.dictItemTable.toggleRowSelection(row, false)
          this.$modal.msgSuccess("删除成功")
        })
    },
    // 改变状态
    handleStatusChange(row) {
      // 让按钮返回原样
      this.btnBlur()

      dictItemApi
        .changeStatus({
          dictItemId: row.dictItemId,
          status: row.status === "1" ? "0" : "1"
        })
        .then((data) => {
          this.$modal.msgSuccess("改变状态成功")
          this.getList()
        })
    },
    // 改变是否可选
    handleDisabledChange(row) {
      dictItemApi
        .changeStatus({
          dictItemId: row.dictItemId,
          dictDisabled: row.dictDisabled === "1" ? "0" : "1"
        })
        .then((data) => {
          this.$modal.msgSuccess("改变禁选状态成功")
          this.getList()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.xiaobu-container {
  .tips {
    font-size: 24px;
    margin-left: 12px;
    color: $mainColor;
  }
}
</style>
